import { ICompany } from './ICompany';

export class Place {

    constructor (
        public company: ICompany,
        public name: string
    ) { }

    public getFullName(html: boolean = false) {
        let fullname = this.company.fullname;
        if (html) {
            fullname = "<strong>" + fullname + "</strong>";
        }
        if (this.name != null && this.name.length > 0) {
            fullname += " - " + this.name;
        }
        return fullname;
    }

    public getShortName() {
        if (this.name != null && this.name.length > 0) {
            return this.name;
        } else {
            return this.company.fullname;
        }
    }
}
